'use strict';

import {createApp} from 'vue';
import {createRouter, createWebHistory} from 'vue-router';
import * as uiv from 'uiv';
import appVue from './app.vue';
import routes from './routes.js';

import limaApi from '../lib/services/lima-api';
import limaTranslate from '../lib/services/lima-translate.js';
import limaMessageBox from '../lib/services/lima-message-box.js';
import localeJa from '../lib/locale/lang/ja-JP.js';
import localeEn from '../lib/locale/lang/en-US.js';

async function routing(to, from, next) {
  let nextTo;
  try {
    if (to.query.access_token) {
      await limaApi.tokenLogin({token:to.query.access_token});
      delete to.query.access_token;
      nextTo = {path:to.path, query:to.query};
    }
    if (!limaApi.state.isLoggedIn && to.matched.some(record => !record.meta.public)) {
      // await limaApi.anonymousLogin();
      if (!limaApi.state.isLoggedIn && to.path !== '/login') {
        limaApi.state.returnPath = to.fullPath;
        limaApi.state.loginMessage = 'Please login';
        // console.log('routing unauth: ', from.fullPath, ' => ', to.fullPath);
        return nextTo = {path:'/login', query:to.query};
      }
    }
    if (limaApi.state.currentUser.passwordExpired && to.path !== '/settings') {
      limaApi.state.returnPath = to.fullPath;
      limaApi.state.loginMessage = 'Password has expired';
      // console.log('routing password expired: ', from.fullPath, ' => ', to.fullPath);
      return nextTo = {path:'/settings', query:to.query};
    }
    if (to.matched.some(record => !limaApi.state.hasFunction(_.get(record, 'meta.required'))) && to.path !== '/login') {
      limaApi.state.returnPath = to.fullPath;
      limaApi.state.loginMessage = 'Forbidden';
      // console.log('routing forbidden: ', from.fullPath, ' => ', to.fullPath);
      return nextTo = {path:'/login', query:to.query};
    }
    if (!nextTo) {
      // console.log('routing: ', from.fullPath, ' => ', to.fullPath);
      limaApi.systemProperties().then(data => {
        const brand = data['setting.brand.text'];
        $('#lima-title').text(limaTranslate(to.meta.title) + (brand ? ` - ${brand}` : ''));
      });
    }
  } finally {
    next(nextTo);
  }
}

function parseQuery(query) {
  // make query case insensitive
  return _.reduce(_.trim(query || '').split('&'), (q, kv) => {
    if (!kv || typeof kv !== 'string') return q;
    const idx = kv.indexOf('=');
    const k = _.toLower(decodeURIComponent((idx < 0) ? kv : kv.slice(0, idx)));
    const v = decodeURIComponent((idx < 0) ? '' : kv.slice(idx + 1));
    if (typeof q[k] === 'undefined') {
      q[k] = v;
    // } else if (Array.isArray(q[k])) {
    //   q[k].push(v);
    // } else {
    //   q[k] = [q[k], v];
    }
    return q;
  }, {});
}

function loadLocale() {
  if (limaTranslate.locale === 'ja') {
    _.set(localeJa, 'uiv.datePicker.week1', '月');
    _.set(localeJa, 'uiv.datePicker.week2', '火');
    _.set(localeJa, 'uiv.datePicker.week3', '水');
    _.set(localeJa, 'uiv.datePicker.week4', '木');
    _.set(localeJa, 'uiv.datePicker.week5', '金');
    _.set(localeJa, 'uiv.datePicker.week6', '土');
    _.set(localeJa, 'uiv.datePicker.week7', '日');
    _.set(localeJa, 'uiv.multiSelect.placeholder', '選択...');
    _.set(localeJa, 'uiv.multiSelect.filterPlaceholder', '検索...');
    return localeJa;
  } else {
    return localeEn;
  }
}

const preferredLang = $('html').attr('lang') || navigator.language || (navigator.languages ?? [])[0];
limaTranslate.load({preferredLang}).then(async () => {
  limaMessageBox.translateDefault();
  await limaApi.updateCurrentUser().catch(err => limaApi.logout());
  await limaApi.updateStyle();
  const router = limaApi.router = createRouter({routes, history:createWebHistory(), parseQuery});
  router.beforeEach(routing);
  const app = createApp(appVue);
  app.use(router);
  app.use(uiv, {prefix: 'uiv', locale:loadLocale()});
  await router.isReady();
  app.mount('#limaApp');
});
